import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

import { prop } from "ramda";

function getAspectRatio(name, orientation) {
  // ratios in landscape
  const ratios = {
    "DIN-A": [1, Math.SQRT2],
    phi: [1 + Math.sqrt(5), 2],
    "1:1": [1, 1],
    "5:4": [5, 4],
    "4:3": [4, 3],
    "3:2": [3, 2],
    "16:9": [16, 9],
    "3:1": [3, 1]
  };
  let ratio = prop(name, ratios);
  ratio = orientation === "portrait" ? ratio.reverse() : ratio;
  return (ratio[0] / ratio[1]) * 100;
}

// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. ArrowFunctionExpression in CSS prop.

const Ratio = styled("div")(props => ({
  position: "relative",
  backgroundColor: "rgb(53, 53, 53)",
  // border: "1px solid rebeccapurple",
  "&::after": {
    content: '""',
    display: "block",
    height: 0,
    width: "100%",
    paddingBottom: `${props.aspectRatio}%`
  },
  "& > *": {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    maxWidth: "100%",
    maxHeight: "100%",
    display: "block",
    width: "auto",
    height: "auto",
    margin: "auto"
  }
}));

function IntrinsicAspectRatio({ ratio, orientation, children, className, ...props }) {
  const aspectRatio = getAspectRatio(ratio, orientation);
  return (
    <Ratio {...props} className={className} aspectRatio={aspectRatio}>
      {children}
    </Ratio>
  );
}

IntrinsicAspectRatio.propTypes = {
  ratio: PropTypes.string.isRequired,
  orientation: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  className: PropTypes.string
};

export default IntrinsicAspectRatio;
